import { SumArrayElements } from "../../../../shared/scripts/array-functions";
import { AggregatedParticipants, Participant } from "./enrollment.entities";
import { IEnrollmentPageData } from "./enrollment.page";
import { ChartDataPoint } from "./enrollment.chart-controller";


var Highcharts = require('highcharts/highcharts');
//require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);

export class EnrollmentGauges {

    parent: IEnrollmentPageData;

    rvlcGauge: any;
    rvlcChart: any;

    rvlcTarget: number;


    constructor(parent: IEnrollmentPageData) {
        this.parent = parent;
    }

    UpdateData(aggregatedParticipants: AggregatedParticipants): void {

    }

    private initializeGauge(id: string, current: number, target: number, totalLabel: string): any {

    }

    private initializeChart(id: string, target?: number): any {

    }

    private createChartData(participants: Participant[]): ChartDataPoint[] {
        return [];
    }

}